import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import classNames from "classnames";
import { MainStore } from "../../stores/MainStore";
import Image from "../Image";
import Label from "../Label";
import { observer } from "mobx-react";
interface IProps {
  store: MainStore;
  customColor?: string;
}
interface State {
  activeTabIndex: number;
  onSelect: boolean;
}
@observer
class TabView extends Component<
  IProps & React.HTMLAttributes<HTMLDivElement>,
  State
> {
  state = {
    activeTabIndex: 0,
    onSelect: false
  };
  renderHeader() {
    const { children, customColor } = this.props;
    const { activeTabIndex, onSelect } = this.state;
    const { store } = this.props;
    if (!store) return null;
    let titleIcon = "";
    if (!children) return null;
    const tabClasses = classNames(
      classes.TabViewHeader,
      onSelect ? classes.onSelect : "",
      (children as HTMLElement[]).length === 2 ? classes.TwoChilds : ""
    );
    return (
      <div className={tabClasses}>
        {(children as HTMLElement[]).map((htmlElement: any, index: number) => {
          titleIcon = htmlElement.props["data-titleicon"] || null;
          let styles = {};
          if (customColor && index === activeTabIndex) {
            /// is active
            styles = {
              backgroundColor: customColor
            };
          }
          return (
            <div
              className={[
                classes.TabViewHeaderCol,
                index === activeTabIndex ? classes.active : ""
              ]
                .filter(c => c !== "")
                .join(" ")}
              key={Math.random()}
              style={styles}
              onClick={e => {
                this.setState({
                  activeTabIndex: index,
                  onSelect: !onSelect
                });
              }}
            >
              {titleIcon && (
                <Image
                  extraSmall
                  src={titleIcon}
                  alt={htmlElement.props.title}
                />
              )}
              <Label
                left={store.screen.isMobile}
                bold
                uppercase
                text={htmlElement.props.title}
              />
            </div>
          );
        })}
      </div>
    );
  }

  renderBody() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;
    if (!children) return null;
    const activeChildren = (children as HTMLElement[])[activeTabIndex];
    return (
      <div key={Math.random()} className={classes.TabViewBody}>
        {activeChildren}
      </div>
    );
  }

  render() {
    const tabViewClasses = classNames(classes.TabView);
    return (
      <div className={tabViewClasses}>
        {this.renderHeader()}
        {this.renderBody()}
      </div>
    );
  }
}
export default TabView;
